import { render } from "./PreviewVideoModal.vue?vue&type=template&id=39d3eb58&scoped=true"
import script from "./PreviewVideoModal.vue?vue&type=script&lang=js"
export * from "./PreviewVideoModal.vue?vue&type=script&lang=js"

import "./PreviewVideoModal.vue?vue&type=style&index=0&id=39d3eb58&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d3eb58"]])

export default __exports__